import React from 'react';
import { Col } from 'reactstrap';
import { getTranslationKey } from '../../modules/utils/helpers';

interface PricingItemProps {
  children: React.ReactNode;
  lg?: number | string;
  xl?: number | string;
  md?: number | string;
  className?: string;
  bestPrice?: boolean;
  mostSelected?: boolean;
}

const PricingItem: React.FC<PricingItemProps> = ({
  children,
  lg,
  xl,
  md,
  className,
  bestPrice,
  mostSelected
}) => (
  <Col xl={xl || 4} lg={lg || 5} md={md || 6} sm="12" className="pr-md-0 pl-md-0 m-b-20">
    {(mostSelected || bestPrice) && (
      <div className="pricing-item-badge">
        <h4 className="pricing-item-badge-text">
          {bestPrice
            ? getTranslationKey('pricingTables.best_price')
            : mostSelected
            ? getTranslationKey('pricingTables.most_selected')
            : ''}
        </h4>
      </div>
    )}

    <div className={'pricing-item' + (className ? ' ' + className : '')}>{children}</div>
  </Col>
);

export default PricingItem;
